export default __webpack_public_path__ + "static/media/idealProtectCrossfire.ba988377.jpg";